import _implicitStylesheets from "./tableauIcon.css";
import _implicitScopedStylesheets from "./tableauIcon.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<svg${"a0:width"}${"a0:height"} viewBox="0 0 62 62" version="1.1"${3}><title${3}>${"t2"}</title><defs${3}><rect${"a4:id"} x="0" y="0" width="53.2" height="53.2"${3}/></defs><g${"a5:id"} stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"${3}><g${"a6:id"}${3}><mask${"a7:id"} style="mask-type: alpha" maskUnits="userSpaceOnUse" x="4" y="4" width="56" height="56"${3}><rect x="4.12891" y="4.12903" width="54.9161" height="54.9161" fill="white"${3}/></mask><g mask="url(#mask0)"${3}><path d="M32.7893 32.6173V38.9669H30.4725V32.6173H24.6377V30.3863H30.4725V24.0366H32.7893V30.3863H38.6241V32.6173H32.7893Z" fill="#E8762C"${3}/><path d="M21.6344 40.7683V35.0193H19.6608V40.7683H14.3408V42.4844H19.6608V48.1477H21.6344V42.4844H26.8686V40.7683H21.6344Z" fill="#C72035"${3}/><path d="M43.6003 20.3458V14.6826H41.6268V20.3458H36.3926V22.1478H41.6268V27.811H43.6003V22.1478H48.8345V20.3458H43.6003Z" fill="#59879B"${3}/><path d="M32.5319 47.0318V43.0847H30.8158V47.0318H27.2119V48.5763H30.8158V52.6092H32.5319V48.5763H36.05V47.0318H32.5319Z" fill="#5B6591"${3}/><path d="M21.5486 20.3458V14.6826H19.6608V20.3458H14.3408V22.062H19.6608V27.811H21.5486V22.062H26.8686V20.3458H21.5486Z" fill="#EB912C"${3}/><path d="M49.3493 30.7287V26.7816H47.6332V30.7287H44.0293V32.2732H47.6332V36.2203H49.3493V32.2732H52.8674V30.7287H49.3493Z" fill="#5B6591"${3}/><path d="M43.6003 40.7683V35.0193H41.6268V40.7683H36.3926V42.4844H41.6268V48.1477H43.6003V42.4844H48.8345V40.7683H43.6003Z" fill="#1F447E"${3}/><path d="M32.2739 14.5116V10.5645H30.9868V14.5116H27.4688V15.7128H30.9868V19.5741H32.2739V15.7128H35.792V14.5116H32.2739Z" fill="#7099A6"${3}/><path d="M15.1128 30.9011V27.0398H13.8257V30.9011H10.3076V32.1024H13.8257V35.9637H15.1128V32.1024H18.6308V30.9011H15.1128Z" fill="#7099A6"${3}/></g></g></g></svg>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, gid: api_scoped_id, sp: api_static_part, st: api_static_fragment} = $api;
  return [api_static_fragment($fragment1, 1, [api_static_part(0, {
    attrs: {
      "width": $cmp.width,
      "height": $cmp.height
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.alternativeText)), api_static_part(4, {
    attrs: {
      "id": api_scoped_id("path-1")
    }
  }, null), api_static_part(5, {
    attrs: {
      "id": api_scoped_id("AXPL-product-icons-/-tableau")
    }
  }, null), api_static_part(6, {
    attrs: {
      "id": api_scoped_id("Analytics")
    }
  }, null), api_static_part(7, {
    attrs: {
      "id": api_scoped_id("mask0")
    }
  }, null)])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2kvh1v9cas5";
tmpl.legacyStylesheetToken = "appx-productIcons_tableauIcon";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
